// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-axios'

import type {
  ActivateAccountData,
  ActivateAccountError,
  ActivateAccountResponse,
  AddExpertReviewData,
  AddExpertReviewError,
  AddExpertReviewResponse,
  AddProjectEvalData,
  AddProjectEvalError,
  AddProjectEvalResponse,
  AddProjectQueryLogGroupRanksData,
  AddProjectQueryLogGroupRanksError,
  AddProjectQueryLogGroupRanksResponse,
  AddUserFeedbackData,
  AddUserFeedbackError,
  AddUserFeedbackResponse,
  CheckCleanlabAdminData,
  CheckCleanlabAdminResponse,
  ConsultAiGuidanceData,
  ConsultAiGuidanceError,
  ConsultAiGuidanceResponse,
  CopyProjectSettingsData,
  CopyProjectSettingsError,
  CopyProjectSettingsResponse,
  CreateAccessKeyData,
  CreateAccessKeyError,
  CreateAccessKeyResponse,
  CreateAiGuidanceData,
  CreateAiGuidanceError,
  CreateAiGuidanceResponse,
  CreateClassificationData,
  CreateClassificationError,
  CreateClassificationOptionData,
  CreateClassificationOptionError,
  CreateClassificationOptionResponse,
  CreateClassificationResponse,
  CreateDeterministicEvalData,
  CreateDeterministicEvalError,
  CreateDeterministicEvalResponse,
  CreateDeterministicGuardrailData,
  CreateDeterministicGuardrailError,
  CreateDeterministicGuardrailResponse,
  CreateExpertAnswerData,
  CreateExpertAnswerError,
  CreateExpertAnswerResponse,
  CreateExpertReviewData,
  CreateExpertReviewError,
  CreateExpertReviewResponse,
  CreateManagedOrganizationData,
  CreateManagedOrganizationError,
  CreateManagedOrganizationResponse,
  CreateOrganizationSetupIntentData,
  CreateOrganizationSetupIntentError,
  CreateOrganizationSetupIntentResponse,
  CreateProjectData,
  CreateProjectError,
  CreateProjectFromTemplateData,
  CreateProjectFromTemplateError,
  CreateProjectFromTemplateResponse,
  CreateProjectResponse,
  CreatePromptRecommendationData,
  CreatePromptRecommendationError,
  CreatePromptRecommendationResponse,
  CreateRemediationData,
  CreateRemediationError,
  CreateRemediationResponse,
  DeleteAccessKeyData,
  DeleteAccessKeyError,
  DeleteAccessKeyResponse,
  DeleteAiGuidanceData,
  DeleteAiGuidanceError,
  DeleteAiGuidanceResponse,
  DeleteClassificationData,
  DeleteClassificationError,
  DeleteClassificationOptionData,
  DeleteClassificationOptionError,
  DeleteClassificationOptionResponse,
  DeleteClassificationResponse,
  DeleteDeterministicEvalData,
  DeleteDeterministicEvalError,
  DeleteDeterministicEvalResponse,
  DeleteDeterministicGuardrailData,
  DeleteDeterministicGuardrailError,
  DeleteDeterministicGuardrailResponse,
  DeleteExpertAnswerData,
  DeleteExpertAnswerError,
  DeleteExpertAnswerResponse,
  DeleteExpertReviewData,
  DeleteExpertReviewError,
  DeleteExpertReviewResponse,
  DeleteProjectData,
  DeleteProjectError,
  DeleteProjectResponse,
  DeleteQueryLogData,
  DeleteQueryLogError,
  DeleteQueryLogResponse,
  DeleteRemediationData,
  DeleteRemediationError,
  DeleteRemediationResponse,
  DeleteUserData,
  DeleteUserError,
  DeleteUserResponse,
  DetectQueryData,
  DetectQueryError,
  DetectQueryResponse,
  EditAnswerData,
  EditAnswerError,
  EditAnswerResponse,
  EditDraftAnswerData,
  EditDraftAnswerError,
  EditDraftAnswerResponse,
  EditDraftExpertAnswerData,
  EditDraftExpertAnswerError,
  EditDraftExpertAnswerResponse,
  EditDraftGuidanceData,
  EditDraftGuidanceError,
  EditDraftGuidanceResponse,
  EditExpertAnswerData,
  EditExpertAnswerError,
  EditExpertAnswerResponse,
  EditGuidanceData,
  EditGuidanceError,
  EditGuidanceResponse,
  ExportProjectData,
  ExportProjectError,
  ExportProjectToS3Data,
  ExportProjectToS3Error,
  ExportQueryLogGroupsToS3Data,
  ExportQueryLogGroupsToS3Error,
  GenerateRegexData,
  GenerateRegexError,
  GenerateRegexResponse2,
  GetAccessKeyData,
  GetAccessKeyError,
  GetAccessKeyResponse,
  GetAiGuidanceData,
  GetAiGuidanceError,
  GetAiGuidanceResponse,
  GetAllIndividualOrganizationsData,
  GetAllIndividualOrganizationsResponse,
  GetAllManagedOrganizationsData,
  GetAllManagedOrganizationsResponse,
  GetClassificationData,
  GetClassificationError,
  GetClassificationOptionData,
  GetClassificationOptionError,
  GetClassificationOptionResponse,
  GetClassificationResponse,
  GetClassificationsDisplayData,
  GetClassificationsDisplayError,
  GetClassificationsDisplayResponse,
  GetClusteringStatusAdminData,
  GetClusteringStatusAdminError,
  GetClusteringStatusAdminResponse,
  GetConversationHistoryData,
  GetConversationHistoryError,
  GetConversationHistoryResponse,
  GetCurrentPromptData,
  GetCurrentPromptError,
  GetCurrentPromptResponse,
  GetDeterministicEvalData,
  GetDeterministicEvalError,
  GetDeterministicEvalResponse,
  GetDeterministicGuardrailData,
  GetDeterministicGuardrailError,
  GetDeterministicGuardrailResponse,
  GetExpertAnswerData,
  GetExpertAnswerError,
  GetExpertAnswerResponse,
  GetExpertAnswerWithResolvedLogsCountData,
  GetExpertAnswerWithResolvedLogsCountError,
  GetExpertAnswerWithResolvedLogsCountResponse,
  GetExpertReviewData,
  GetExpertReviewError,
  GetExpertReviewResponse,
  GetMetricsData,
  GetMyselfData,
  GetMyselfFromApiKeyData,
  GetMyselfFromApiKeyResponse,
  GetMyselfResponse,
  GetOrganizationAsAdminData,
  GetOrganizationAsAdminError,
  GetOrganizationAsAdminResponse,
  GetOrganizationCardDetailsData,
  GetOrganizationCardDetailsError,
  GetOrganizationCardDetailsResponse,
  GetOrganizationData,
  GetOrganizationError,
  GetOrganizationInvoicesData,
  GetOrganizationInvoicesError,
  GetOrganizationInvoicesResponse,
  GetOrganizationMembersData,
  GetOrganizationMembersError,
  GetOrganizationMembersPublicData,
  GetOrganizationMembersPublicError,
  GetOrganizationMembersPublicResponse,
  GetOrganizationMembersResponse,
  GetOrganizationPlanDetailsData,
  GetOrganizationPlanDetailsError,
  GetOrganizationPlanDetailsResponse,
  GetOrganizationResponse,
  GetOrganizationUsageData,
  GetOrganizationUsageError,
  GetOrganizationUsageResponse,
  GetProjectAnalyticsData,
  GetProjectAnalyticsError,
  GetProjectAnalyticsResponse,
  GetProjectData,
  GetProjectError,
  GetProjectEvalsData,
  GetProjectEvalsError,
  GetProjectEvalsResponse,
  GetProjectGuardrailsData,
  GetProjectGuardrailsError,
  GetProjectGuardrailsNextData,
  GetProjectGuardrailsNextError,
  GetProjectGuardrailsNextResponse,
  GetProjectGuardrailsResponse,
  GetProjectIdFromAccessKeyData,
  GetProjectIdFromAccessKeyResponse,
  GetProjectResponse,
  GetProjectWithUnaddressedCountsData,
  GetProjectWithUnaddressedCountsError,
  GetProjectWithUnaddressedCountsResponse,
  GetQueryLogData,
  GetQueryLogError,
  GetQueryLogResponse,
  GetRemediationData,
  GetRemediationError,
  GetRemediationResponse,
  GetRemediationWithResolvedLogsCountData,
  GetRemediationWithResolvedLogsCountError,
  GetRemediationWithResolvedLogsCountResponse,
  GetTlmExplanationData,
  GetTlmExplanationError,
  GetTlmExplanationResponse,
  GetUserOrganizationPermissionsData,
  GetUserOrganizationPermissionsError,
  GetUserOrganizationPermissionsResponse,
  GetUserOrganizationsData,
  GetUserOrganizationsResponse,
  GetUsersData,
  GetUsersResponse,
  InviteSmeData,
  InviteSmeError,
  InviteSmeResponse,
  ListAiGuidanceData,
  ListAiGuidanceError,
  ListAiGuidanceResponse,
  ListAppliedToLogsData,
  ListAppliedToLogsError,
  ListAppliedToLogsResponse,
  ListClassificationOptionsData,
  ListClassificationOptionsError,
  ListClassificationOptionsResponse,
  ListClassificationsData,
  ListClassificationsError,
  ListClassificationsResponse,
  ListDeterministicGuardrailsData,
  ListDeterministicGuardrailsError,
  ListDeterministicGuardrailsResponse,
  ListExpertAnswersData,
  ListExpertAnswersError,
  ListExpertAnswersResponse,
  ListExpertReviewAppliedToLogsData,
  ListExpertReviewAppliedToLogsError,
  ListExpertReviewAppliedToLogsResponse,
  ListExpertReviewsData,
  ListExpertReviewsError,
  ListExpertReviewsResponse,
  ListIssuesData,
  ListIssuesError,
  ListIssuesResponse,
  ListLogsByIssueData,
  ListLogsByIssueError,
  ListLogsByIssueResponse,
  ListProjectAccessKeysData,
  ListProjectAccessKeysError,
  ListProjectAccessKeysResponse,
  ListProjectsAdminData,
  ListProjectsAdminError,
  ListProjectsAdminResponse,
  ListProjectsData,
  ListProjectsError,
  ListProjectsResponse,
  ListQueryLogGroupsData,
  ListQueryLogGroupsError,
  ListQueryLogGroupsResponse,
  ListQueryLogsByGroupData,
  ListQueryLogsByGroupError,
  ListQueryLogsByGroupResponse,
  ListQueryLogsData,
  ListQueryLogsError,
  ListQueryLogsResponse,
  ListRemediationsData,
  ListRemediationsError,
  ListRemediationsResponse,
  ListResolvedLogsData,
  ListResolvedLogsError,
  ListResolvedLogsResponse,
  PatchDeterministicEvalFallbackPriorityData,
  PatchDeterministicEvalFallbackPriorityError,
  PatchDeterministicEvalFallbackPriorityResponse,
  PatchDeterministicGuardrailFallbackPriorityData,
  PatchDeterministicGuardrailFallbackPriorityError,
  PatchDeterministicGuardrailFallbackPriorityResponse,
  PatchProjectEvalGuardrailedFallbackPriorityData,
  PatchProjectEvalGuardrailedFallbackPriorityError,
  PatchProjectEvalGuardrailedFallbackPriorityResponse,
  PauseExpertAnswerData,
  PauseExpertAnswerError,
  PauseExpertAnswerResponse,
  PauseRemediationData,
  PauseRemediationError,
  PauseRemediationResponse,
  PublishExpertAnswerData,
  PublishExpertAnswerError,
  PublishExpertAnswerResponse,
  PublishGuidanceData,
  PublishGuidanceError,
  PublishGuidanceResponse,
  PublishRemediationData,
  PublishRemediationError,
  PublishRemediationResponse,
  RefreshApiKeyData,
  RefreshApiKeyResponse,
  RemoveExpertReviewData,
  RemoveExpertReviewError,
  RemoveExpertReviewResponse,
  RemoveProjectEvalData,
  RemoveProjectEvalError,
  RemoveProjectEvalResponse,
  ResendVerificationEmailData,
  ResendVerificationEmailResponse,
  RevokeAccessKeyData,
  RevokeAccessKeyError,
  RevokeAccessKeyResponse,
  RunQueryLogClusteringAdminData,
  RunQueryLogClusteringAdminError,
  SendGuardrailNotificationManualProjectData,
  SendGuardrailNotificationManualProjectError,
  SendGuardrailNotificationManualProjectResponse,
  SendOutdatedRemediationsNotificationManualProjectData,
  SendOutdatedRemediationsNotificationManualProjectError,
  SendOutdatedRemediationsNotificationManualProjectResponse,
  StartRemediationData,
  StartRemediationError,
  StartRemediationResponse,
  SwitchUserOrganizationData,
  SwitchUserOrganizationError,
  SwitchUserOrganizationResponse,
  TlmChatData,
  TlmChatResponse,
  TlmHealthCheckData,
  TlmHealthCheckResponse,
  UnpauseExpertAnswerData,
  UnpauseExpertAnswerError,
  UnpauseExpertAnswerResponse,
  UnpauseRemediationData,
  UnpauseRemediationError,
  UnpauseRemediationResponse,
  UpdateAccessKeyData,
  UpdateAccessKeyError,
  UpdateAccessKeyResponse,
  UpdateClassificationData,
  UpdateClassificationError,
  UpdateClassificationOptionData,
  UpdateClassificationOptionError,
  UpdateClassificationOptionResponse,
  UpdateClassificationResponse,
  UpdateDeterministicEvalData,
  UpdateDeterministicEvalError,
  UpdateDeterministicEvalResponse,
  UpdateDeterministicGuardrailData,
  UpdateDeterministicGuardrailError,
  UpdateDeterministicGuardrailResponse,
  UpdateExpertReviewData,
  UpdateExpertReviewError,
  UpdateExpertReviewResponse,
  UpdateIssueReviewStatusData,
  UpdateIssueReviewStatusError,
  UpdateIssueReviewStatusResponse,
  UpdateMetadataData,
  UpdateMetadataError,
  UpdateMetadataResponse,
  UpdateOrganizationData,
  UpdateOrganizationError,
  UpdateOrganizationMemberRoleData,
  UpdateOrganizationMemberRoleError,
  UpdateOrganizationMemberRoleResponse,
  UpdateOrganizationResponse,
  UpdateProjectData,
  UpdateProjectError,
  UpdateProjectEvalData,
  UpdateProjectEvalError,
  UpdateProjectEvalResponse,
  UpdateProjectResponse,
  UpdateProjectTemplateStatusData,
  UpdateProjectTemplateStatusError,
  UpdateProjectTemplateStatusResponse,
  UpdateRemediationReviewStatusData,
  UpdateRemediationReviewStatusError,
  UpdateRemediationReviewStatusResponse,
  ValidateQueryData,
  ValidateQueryError,
  ValidateQueryResponse,
} from './types.gen'

export const client = createClient(createConfig())

/**
 * Get Organization
 * Get a single organization.
 */
export const getOrganization = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationResponse,
    GetOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/organizations/{organization_id}',
  })
}

/**
 * Get User Organization Permissions
 * Get the user's permissions for this organization.
 */
export const getUserOrganizationPermissions = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserOrganizationPermissionsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetUserOrganizationPermissionsResponse,
    GetUserOrganizationPermissionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/organizations/{organization_id}/permissions',
  })
}

/**
 * Get Organization Members Public
 * Get a list of organization members with their names and emails.
 */
export const getOrganizationMembersPublic = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationMembersPublicData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationMembersPublicResponse,
    GetOrganizationMembersPublicError,
    ThrowOnError
  >({
    ...options,
    url: '/api/organizations/{organization_id}/members',
  })
}

/**
 * Get Myself
 * Get user info for frontend.
 */
export const getMyself = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyselfData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetMyselfResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/users/myself',
  })
}

/**
 * Get Myself From Api Key
 * Get user when authenticated with API key.
 */
export const getMyselfFromApiKey = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyselfFromApiKeyData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetMyselfFromApiKeyResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/users/myself/api-key',
  })
}

/**
 * Refresh Api Key
 * Refresh the API key for an authenticated user
 */
export const refreshApiKey = <ThrowOnError extends boolean = false>(
  options?: Options<RefreshApiKeyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<RefreshApiKeyResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/users/myself/api-key/refresh',
  })
}

/**
 * Get User Organizations
 * Get the organizations for an authenticated user
 */
export const getUserOrganizations = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserOrganizationsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetUserOrganizationsResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/users/myself/organizations',
  })
}

/**
 * Activate Account
 * Activate an authenticated user's account
 */
export const activateAccount = <ThrowOnError extends boolean = false>(
  options: Options<ActivateAccountData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    ActivateAccountResponse,
    ActivateAccountError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/users/activate_account',
  })
}

/**
 * Resend Verification Email
 * Resend verification email to the specified user through Auth0.
 */
export const resendVerificationEmail = <ThrowOnError extends boolean = false>(
  options?: Options<ResendVerificationEmailData, ThrowOnError>
) => {
  return (options?.client ?? client).post<ResendVerificationEmailResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/users/verification/resend',
  })
}

/**
 * Get Project Id From Access Key
 * Get the project ID from an access key.
 */
export const getProjectIdFromAccessKey = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectIdFromAccessKeyData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetProjectIdFromAccessKeyResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/projects/id_from_access_key',
  })
}

/**
 * Delete Project
 * Delete a project.
 */
export const deleteProject = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteProjectData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteProjectResponse,
    DeleteProjectError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}',
  })
}

/**
 * Get Project
 * Get a single project.
 */
export const getProject = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetProjectResponse, GetProjectError, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}',
  })
}

/**
 * Update Project
 * Update a project.
 */
export const updateProject = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectData, ThrowOnError>
) => {
  return (options?.client ?? client).put<UpdateProjectResponse, UpdateProjectError, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}',
  })
}

/**
 * Get Project With Unaddressed Counts
 * Get a single project with unaddressed remediation counts.
 */
export const getProjectWithUnaddressedCounts = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectWithUnaddressedCountsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectWithUnaddressedCountsResponse,
    GetProjectWithUnaddressedCountsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/with-unaddressed-counts',
  })
}

/**
 * List Projects
 * List projects for organization.
 */
export const listProjects = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<ListProjectsResponse, ListProjectsError, ThrowOnError>({
    ...options,
    url: '/api/projects/',
  })
}

/**
 * Create Project
 * Create a new project.
 */
export const createProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectData, ThrowOnError>
) => {
  return (options?.client ?? client).post<CreateProjectResponse, CreateProjectError, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/',
  })
}

/**
 * Create Project From Template
 * Create a new project from a template project.
 */
export const createProjectFromTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectFromTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateProjectFromTemplateResponse,
    CreateProjectFromTemplateError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/create-from-template',
  })
}

/**
 * Detect Query
 * Detect whether a response, given the provided query and context, is potentially bad.
 * No query is logged in the project for this API route.
 * Optionally, users can add custom evals for each request, or swap in different settings for the current project's evals.
 */
export const detectQuery = <ThrowOnError extends boolean = false>(
  options: Options<DetectQueryData, ThrowOnError>
) => {
  return (options?.client ?? client).post<DetectQueryResponse, DetectQueryError, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/detect',
  })
}

/**
 * Export Project
 * Export all data for a project as a JSON file.
 */
export const exportProject = <ThrowOnError extends boolean = false>(
  options?: Options<ExportProjectData, ThrowOnError>
) => {
  return (options?.client ?? client).get<unknown, ExportProjectError, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}/export',
  })
}

/**
 * Export Project To S3
 * Trigger S3 export as a background task.
 *
 * This endpoint returns immediately (202 Accepted) while the export runs asynchronously.
 * Query logs are exported in paginated batches as separate files for low memory usage.
 */
export const exportProjectToS3 = <ThrowOnError extends boolean = false>(
  options?: Options<ExportProjectToS3Data, ThrowOnError>
) => {
  return (options?.client ?? client).post<unknown, ExportProjectToS3Error, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}/export-to-s3',
  })
}

/**
 * Export Query Log Groups To S3
 * Trigger S3 export as a background task for query log groups.
 *
 * This endpoint returns immediately (202 Accepted) while the export runs asynchronously.
 * Query log groups are exported in paginated batches as separate files for low memory usage.
 */
export const exportQueryLogGroupsToS3 = <ThrowOnError extends boolean = false>(
  options?: Options<ExportQueryLogGroupsToS3Data, ThrowOnError>
) => {
  return (options?.client ?? client).post<unknown, ExportQueryLogGroupsToS3Error, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}/export-query-log-groups-to-s3',
  })
}

/**
 * Consult Ai Guidance
 */
export const consultAiGuidance = <ThrowOnError extends boolean = false>(
  options: Options<ConsultAiGuidanceData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ConsultAiGuidanceResponse,
    ConsultAiGuidanceError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/consult',
  })
}

/**
 * Validate Query
 * Evaluate whether a response, given the provided query and context, is potentially bad.
 * If the response is flagged as bad, a lookup is performed to find an alternate expert answer.
 * If there is no expert answer available, this query will be recorded in the project for SMEs to answer.
 */
export const validateQuery = <ThrowOnError extends boolean = false>(
  options: Options<ValidateQueryData, ThrowOnError>
) => {
  return (options?.client ?? client).post<ValidateQueryResponse, ValidateQueryError, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/validate',
  })
}

/**
 * Get Project Evals
 * Get the evaluations config for a project with optional pagination.
 */
export const getProjectEvals = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectEvalsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectEvalsResponse,
    GetProjectEvalsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/evals',
  })
}

/**
 * Add Project Eval
 * Create a new custom eval for a project.
 */
export const addProjectEval = <ThrowOnError extends boolean = false>(
  options: Options<AddProjectEvalData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    AddProjectEvalResponse,
    AddProjectEvalError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/evals',
  })
}

/**
 * Get Project Guardrails
 * Get the guardrails for a project.
 */
export const getProjectGuardrails = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectGuardrailsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectGuardrailsResponse,
    GetProjectGuardrailsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/guardrails',
  })
}

/**
 * Get Project Guardrails Next
 * Get the guardrails for a project.
 */
export const getProjectGuardrailsNext = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectGuardrailsNextData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectGuardrailsNextResponse,
    GetProjectGuardrailsNextError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/guardrails-next',
  })
}

/**
 * Remove Project Eval
 * Remove a custom eval for a project.
 */
export const removeProjectEval = <ThrowOnError extends boolean = false>(
  options?: Options<RemoveProjectEvalData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    RemoveProjectEvalResponse,
    RemoveProjectEvalError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/evals/{eval_key}',
  })
}

/**
 * Update Project Eval
 * Update an existing eval for a project.
 */
export const updateProjectEval = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectEvalData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateProjectEvalResponse,
    UpdateProjectEvalError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/evals/{eval_key}',
  })
}

/**
 * Increment or decrement fallback priority for an eval by 1
 * The smaller the fallback priority number, the higher the priority of the guardrail.
 * If the operation is "increment", fallback priority of the target eval will be decreased by 1, while the fallback priority of the next highest eval will be increased by 1.
 * If the operation is "decrement", the fallback priority of the target eval will be increased by 1, while the fallback priority of the next lowest eval will be decreased by 1.
 */
export const patchProjectEvalGuardrailedFallbackPriority = <ThrowOnError extends boolean = false>(
  options?: Options<PatchProjectEvalGuardrailedFallbackPriorityData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PatchProjectEvalGuardrailedFallbackPriorityResponse,
    PatchProjectEvalGuardrailedFallbackPriorityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/evals/{eval_key}/fallback_priority',
  })
}

/**
 * Invite Sme
 * Invite a subject matter expert to view a specific query log or remediation.
 *
 * Returns:
 * SMERemediationNotificationResponse with status and notification details
 */
export const inviteSme = <ThrowOnError extends boolean = false>(
  options: Options<InviteSmeData, ThrowOnError>
) => {
  return (options?.client ?? client).post<InviteSmeResponse, InviteSmeError, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/notifications',
  })
}

/**
 * Send Guardrail Notification Manual Project
 * Manually send a guardrail threshold notification email for a project.
 *
 * Builds a deeplink to the project's query logs using the provided
 * URL query string and dispatches a templated email to the specified
 * recipient. Intended for demo/manual sends today and reusable for
 * future automated alerts.
 *
 * Args:
 * project_id: The target project ID.
 * request: Guardrail notification payload (recipient, guardrail name, threshold, query string).
 *
 * Returns:
 * GuardrailManualSendResponse indicating the notification was sent.
 */
export const sendGuardrailNotificationManualProject = <ThrowOnError extends boolean = false>(
  options: Options<SendGuardrailNotificationManualProjectData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SendGuardrailNotificationManualProjectResponse,
    SendGuardrailNotificationManualProjectError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/notifications/guardrail',
  })
}

/**
 * Send Outdated Remediations Notification Manual Project
 * Manually send an outdated remediations notification email for a project.
 *
 * Builds a deeplink to the project's remediations view using the provided
 * URL query string and dispatches a templated email to the specified
 * recipient. Includes a dynamic subject line with the date range.
 *
 * Args:
 * project_id: The target project ID.
 * request: Outdated remediations payload (recipient, date range label, threshold days, query string, count).
 *
 * Returns:
 * OutdatedRemediationsManualSendResponse indicating the notification was sent.
 */
export const sendOutdatedRemediationsNotificationManualProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendOutdatedRemediationsNotificationManualProjectData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SendOutdatedRemediationsNotificationManualProjectResponse,
    SendOutdatedRemediationsNotificationManualProjectError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/notifications/outdated-remediations',
  })
}

/**
 * Generate Regex
 * Generate a regex for a project.
 */
export const generateRegex = <ThrowOnError extends boolean = false>(
  options: Options<GenerateRegexData, ThrowOnError>
) => {
  return (options?.client ?? client).post<GenerateRegexResponse2, GenerateRegexError, ThrowOnError>(
    {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      url: '/api/projects/{project_id}/regex',
    }
  )
}

/**
 * Delete Access Key
 * Delete an existing access key.
 */
export const deleteAccessKey = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteAccessKeyData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteAccessKeyResponse,
    DeleteAccessKeyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/access_keys/{access_key_id}',
  })
}

/**
 * Get Access Key
 * Get a single access key.
 */
export const getAccessKey = <ThrowOnError extends boolean = false>(
  options?: Options<GetAccessKeyData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetAccessKeyResponse, GetAccessKeyError, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}/access_keys/{access_key_id}',
  })
}

/**
 * Update Access Key
 * Update an existing access key.
 */
export const updateAccessKey = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAccessKeyData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateAccessKeyResponse,
    UpdateAccessKeyError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/access_keys/{access_key_id}',
  })
}

/**
 * List Project Access Keys
 * List all access keys for a project.
 */
export const listProjectAccessKeys = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectAccessKeysData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListProjectAccessKeysResponse,
    ListProjectAccessKeysError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/access_keys/',
  })
}

/**
 * Create Access Key
 * Create a new access key.
 */
export const createAccessKey = <ThrowOnError extends boolean = false>(
  options: Options<CreateAccessKeyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateAccessKeyResponse,
    CreateAccessKeyError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/access_keys/',
  })
}

/**
 * Revoke Access Key
 * Revoke an access key.
 */
export const revokeAccessKey = <ThrowOnError extends boolean = false>(
  options?: Options<RevokeAccessKeyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    RevokeAccessKeyResponse,
    RevokeAccessKeyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/access_keys/{access_key_id}/revoke',
  })
}

/**
 * Get Classifications Display
 * Get all classifications in human-readable format for frontend display.
 *
 * Returns classifications with:
 * - No server-side fields (IDs, timestamps, user_id)
 * - Resolved relationships (names instead of IDs)
 * - Nested options under classifications
 *
 * Returns empty classifications list if project has no classifications.
 */
export const getClassificationsDisplay = <ThrowOnError extends boolean = false>(
  options?: Options<GetClassificationsDisplayData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetClassificationsDisplayResponse,
    GetClassificationsDisplayError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/classifications/display',
  })
}

/**
 * Delete Classification
 * Delete a classification.
 */
export const deleteClassification = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteClassificationData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteClassificationResponse,
    DeleteClassificationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/classifications/{classification_id}',
  })
}

/**
 * Get Classification
 * Get a single classification by ID.
 */
export const getClassification = <ThrowOnError extends boolean = false>(
  options?: Options<GetClassificationData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetClassificationResponse,
    GetClassificationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/classifications/{classification_id}',
  })
}

/**
 * Update Classification
 * Update an existing classification.
 */
export const updateClassification = <ThrowOnError extends boolean = false>(
  options: Options<UpdateClassificationData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateClassificationResponse,
    UpdateClassificationError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/classifications/{classification_id}',
  })
}

/**
 * List Classifications
 * List all classifications for a project.
 */
export const listClassifications = <ThrowOnError extends boolean = false>(
  options?: Options<ListClassificationsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListClassificationsResponse,
    ListClassificationsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/classifications/',
  })
}

/**
 * Create Classification
 * Create a new classification for a project.
 */
export const createClassification = <ThrowOnError extends boolean = false>(
  options: Options<CreateClassificationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateClassificationResponse,
    CreateClassificationError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/classifications/',
  })
}

/**
 * List Classification Options
 * List all options for a classification.
 */
export const listClassificationOptions = <ThrowOnError extends boolean = false>(
  options?: Options<ListClassificationOptionsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListClassificationOptionsResponse,
    ListClassificationOptionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/classifications/{classification_id}/options',
  })
}

/**
 * Create Classification Option
 * Create a new option for a classification.
 */
export const createClassificationOption = <ThrowOnError extends boolean = false>(
  options: Options<CreateClassificationOptionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateClassificationOptionResponse,
    CreateClassificationOptionError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/classifications/{classification_id}/options',
  })
}

/**
 * Delete Classification Option
 * Delete a classification option.
 */
export const deleteClassificationOption = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteClassificationOptionData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteClassificationOptionResponse,
    DeleteClassificationOptionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/classifications/{classification_id}/options/{classification_option_id}',
  })
}

/**
 * Get Classification Option
 * Get a single classification option by ID.
 */
export const getClassificationOption = <ThrowOnError extends boolean = false>(
  options?: Options<GetClassificationOptionData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetClassificationOptionResponse,
    GetClassificationOptionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/classifications/{classification_id}/options/{classification_option_id}',
  })
}

/**
 * Update Classification Option
 * Update an existing classification option.
 */
export const updateClassificationOption = <ThrowOnError extends boolean = false>(
  options: Options<UpdateClassificationOptionData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateClassificationOptionResponse,
    UpdateClassificationOptionError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/classifications/{classification_id}/options/{classification_option_id}',
  })
}

/**
 * Get Organization Usage
 * Get usage iFrame URL for an organization.
 */
export const getOrganizationUsage = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationUsageData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationUsageResponse,
    GetOrganizationUsageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/organizations/{organization_id}/billing/usage',
  })
}

/**
 * Get Organization Invoices
 * Get invoices iFrame URL for an organization.
 */
export const getOrganizationInvoices = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationInvoicesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationInvoicesResponse,
    GetOrganizationInvoicesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/organizations/{organization_id}/billing/invoices',
  })
}

/**
 * Get Organization Card Details
 * Get card details for an organization.
 */
export const getOrganizationCardDetails = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationCardDetailsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationCardDetailsResponse,
    GetOrganizationCardDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/organizations/{organization_id}/billing/card-details',
  })
}

/**
 * Create Organization Setup Intent
 * Create a setup intent for an organization.
 */
export const createOrganizationSetupIntent = <ThrowOnError extends boolean = false>(
  options?: Options<CreateOrganizationSetupIntentData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateOrganizationSetupIntentResponse,
    CreateOrganizationSetupIntentError,
    ThrowOnError
  >({
    ...options,
    url: '/api/organizations/{organization_id}/billing/setup-intent',
  })
}

/**
 * Get Organization Plan Details
 * Get plan details for an organization.
 *
 * This includes the plan name,
 */
export const getOrganizationPlanDetails = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationPlanDetailsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationPlanDetailsResponse,
    GetOrganizationPlanDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/organizations/{organization_id}/billing/plan-details',
  })
}

/**
 * Check Cleanlab Admin
 * Check if the user is a cleanlab admin.
 */
export const checkCleanlabAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<CheckCleanlabAdminData, ThrowOnError>
) => {
  return (options?.client ?? client).get<CheckCleanlabAdminResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/admin/check-cleanlab-admin',
  })
}

/**
 * Get All Managed Organizations
 * Get all managed organizations.
 */
export const getAllManagedOrganizations = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllManagedOrganizationsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetAllManagedOrganizationsResponse, unknown, ThrowOnError>(
    {
      ...options,
      url: '/api/admin/managed-organizations',
    }
  )
}

/**
 * Create Managed Organization
 * Create a managed organization with preconfigured settings.
 */
export const createManagedOrganization = <ThrowOnError extends boolean = false>(
  options: Options<CreateManagedOrganizationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateManagedOrganizationResponse,
    CreateManagedOrganizationError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/admin/managed-organizations',
  })
}

/**
 * Get All Individual Organizations
 * Get all individual organizations.
 */
export const getAllIndividualOrganizations = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllIndividualOrganizationsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAllIndividualOrganizationsResponse,
    unknown,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/individual-organizations',
  })
}

/**
 * Get Organization Members
 * Get all members of an organization.
 */
export const getOrganizationMembers = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationMembersData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationMembersResponse,
    GetOrganizationMembersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/organizations/{organization_id}/members',
  })
}

/**
 * Get Organization As Admin
 * Get a single organization for admin.
 */
export const getOrganizationAsAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationAsAdminData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationAsAdminResponse,
    GetOrganizationAsAdminError,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/organizations/{organization_id}',
  })
}

/**
 * Update Organization
 * Update an organization's email domains.
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrganizationData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateOrganizationResponse,
    UpdateOrganizationError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/admin/organizations/{organization_id}',
  })
}

/**
 * Update Organization Member Role
 * Update the role of a member of an organization.
 */
export const updateOrganizationMemberRole = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateOrganizationMemberRoleData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateOrganizationMemberRoleResponse,
    UpdateOrganizationMemberRoleError,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/organizations/{organization_id}/members/{user_id}/role',
  })
}

/**
 * Get Users
 * Get all users.
 */
export const getUsers = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetUsersResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/admin/users',
  })
}

/**
 * Delete User
 * Delete a user.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteUserData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<DeleteUserResponse, DeleteUserError, ThrowOnError>({
    ...options,
    url: '/api/admin/users/{selected_user_id}',
  })
}

/**
 * Switch User Organization
 * switch the organization of a user.
 */
export const switchUserOrganization = <ThrowOnError extends boolean = false>(
  options?: Options<SwitchUserOrganizationData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    SwitchUserOrganizationResponse,
    SwitchUserOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/users/{selected_user_id}/organization',
  })
}

/**
 * Add Project Query Log Group Ranks
 * Add query log group ranks to a project or update existing query log group ranks.
 */
export const addProjectQueryLogGroupRanks = <ThrowOnError extends boolean = false>(
  options: Options<AddProjectQueryLogGroupRanksData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    AddProjectQueryLogGroupRanksResponse,
    AddProjectQueryLogGroupRanksError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/admin/projects/query_log_group_ranks',
  })
}

/**
 * Run Query Log Clustering Admin
 * Run query log clustering for a project.
 */
export const runQueryLogClusteringAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<RunQueryLogClusteringAdminData, ThrowOnError>
) => {
  return (options?.client ?? client).post<unknown, RunQueryLogClusteringAdminError, ThrowOnError>({
    ...options,
    url: '/api/admin/projects/{project_id}/run_query_log_clustering',
  })
}

/**
 * Get Clustering Status Admin
 * Get the status of clustering for a project.
 */
export const getClusteringStatusAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<GetClusteringStatusAdminData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetClusteringStatusAdminResponse,
    GetClusteringStatusAdminError,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/projects/{project_id}/clustering_status',
  })
}

/**
 * List Projects Admin
 * Get all projects for an organization.
 */
export const listProjectsAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectsAdminData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListProjectsAdminResponse,
    ListProjectsAdminError,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/projects/{organization_id}',
  })
}

/**
 * Copy Project Settings
 * Copy project settings to a new project.
 */
export const copyProjectSettings = <ThrowOnError extends boolean = false>(
  options?: Options<CopyProjectSettingsData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    CopyProjectSettingsResponse,
    CopyProjectSettingsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/projects/copy_project_settings',
  })
}

/**
 * Update Project Template Status
 * Update the is_template flag for a project.
 */
export const updateProjectTemplateStatus = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateProjectTemplateStatusData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UpdateProjectTemplateStatusResponse,
    UpdateProjectTemplateStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/api/admin/projects/{project_id}/update_template_status',
  })
}

/**
 * Get project analytics with optional filtering
 * Retrieve analytics data for a project including queries, bad responses, and answers published.
 *
 * **Metadata Filtering:**
 * - Filter by custom metadata fields using key-value pairs
 * - Supports single values: `{"department": "Engineering"}`
 * - Supports multiple values: `{"priority": ["high", "medium"]}`
 * - Supports null/missing values: `{"department": []}` or `{"department": [null]}`
 *
 * **Available Metadata Fields:**
 * - Only metadata keys that exist on query logs are returned in `metadata_fields`
 * - Fields with ≤12 unique values show as "select" type with checkbox options
 * - Fields with >12 unique values show as "input" type for text search
 * - Fields with no data are excluded from the response entirely
 *
 * **Null Value Behavior:**
 * - Empty arrays `[]` are automatically converted to `[null]` to filter for records where the metadata field is missing or null
 * - Use `[null]` explicitly to filter for records where the field is missing or null
 * - Use `["value1", null, "value2"]` to include both specific values and null values
 * - Records match if the metadata field is null, missing from custom_metadata, or custom_metadata itself is null
 *
 * **Date Filtering:**
 * - Provide `start` only: filter logs created at or after this timestamp
 * - Provide `end` only: filter logs created at or before this timestamp
 * - Provide both: filter logs created within the time range
 * - Provide neither: include all logs regardless of creation time
 */
export const getProjectAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectAnalyticsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectAnalyticsResponse,
    GetProjectAnalyticsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/analytics/',
  })
}

/**
 * List Query Logs
 * List query logs by project ID.
 */
export const listQueryLogs = <ThrowOnError extends boolean = false>(
  options?: Options<ListQueryLogsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<ListQueryLogsResponse, ListQueryLogsError, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}/query_logs/',
  })
}

/**
 * @deprecated
 * List Query Log Groups
 * List query log groups by project ID.
 */
export const listQueryLogGroups = <ThrowOnError extends boolean = false>(
  options?: Options<ListQueryLogGroupsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListQueryLogGroupsResponse,
    ListQueryLogGroupsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/query_logs/groups',
  })
}

/**
 * @deprecated
 * List Query Logs By Group
 * List query log group by remediation ID.
 */
export const listQueryLogsByGroup = <ThrowOnError extends boolean = false>(
  options?: Options<ListQueryLogsByGroupData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListQueryLogsByGroupResponse,
    ListQueryLogsByGroupError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/query_logs/logs_by_group',
  })
}

/**
 * Delete Query Log
 */
export const deleteQueryLog = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteQueryLogData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteQueryLogResponse,
    DeleteQueryLogError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/query_logs/{query_log_id}',
  })
}

/**
 * Get Query Log
 */
export const getQueryLog = <ThrowOnError extends boolean = false>(
  options?: Options<GetQueryLogData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetQueryLogResponse, GetQueryLogError, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}/query_logs/{query_log_id}',
  })
}

/**
 * @deprecated
 * Start Remediation
 */
export const startRemediation = <ThrowOnError extends boolean = false>(
  options?: Options<StartRemediationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    StartRemediationResponse,
    StartRemediationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/query_logs/{query_log_id}/start_remediation',
  })
}

/**
 * Get Conversation History
 */
export const getConversationHistory = <ThrowOnError extends boolean = false>(
  options?: Options<GetConversationHistoryData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetConversationHistoryResponse,
    GetConversationHistoryError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/query_logs/{query_log_id}/conversation_history',
  })
}

/**
 * Add User Feedback
 */
export const addUserFeedback = <ThrowOnError extends boolean = false>(
  options: Options<AddUserFeedbackData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    AddUserFeedbackResponse,
    AddUserFeedbackError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/query_logs/{query_log_id}/user_feedback',
  })
}

/**
 * Update Metadata
 */
export const updateMetadata = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMetadataData, ThrowOnError>
) => {
  return (options?.client ?? client).put<UpdateMetadataResponse, UpdateMetadataError, ThrowOnError>(
    {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      url: '/api/projects/{project_id}/query_logs/{query_log_id}/metadata',
    }
  )
}

/**
 * @deprecated
 * Add Expert Review
 * Add an expert review for a query log.
 */
export const addExpertReview = <ThrowOnError extends boolean = false>(
  options: Options<AddExpertReviewData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    AddExpertReviewResponse,
    AddExpertReviewError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/query_logs/{query_log_id}/expert_review',
  })
}

/**
 * @deprecated
 * Remove Expert Review
 * Remove an expert review from a query log.
 */
export const removeExpertReview = <ThrowOnError extends boolean = false>(
  options?: Options<RemoveExpertReviewData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    RemoveExpertReviewResponse,
    RemoveExpertReviewError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/query_logs/{query_log_id}/expert_review/clear',
  })
}

/**
 * Get Tlm Explanation
 * Get the TLM explanation for a query log.
 */
export const getTlmExplanation = <ThrowOnError extends boolean = false>(
  options?: Options<GetTlmExplanationData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetTlmExplanationResponse,
    GetTlmExplanationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/query_logs/{query_log_id}/tlm_explanation',
  })
}

/**
 * Get Current Prompt
 * Get the most recent system prompt and prompt recommendation job.
 */
export const getCurrentPrompt = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentPromptData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCurrentPromptResponse,
    GetCurrentPromptError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/prompt_recommendations/',
  })
}

/**
 * Create Prompt Recommendation
 */
export const createPromptRecommendation = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePromptRecommendationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePromptRecommendationResponse,
    CreatePromptRecommendationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/prompt_recommendations/',
  })
}

/**
 * @deprecated
 * List Remediations
 * List remediations by project ID.
 */
export const listRemediations = <ThrowOnError extends boolean = false>(
  options?: Options<ListRemediationsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListRemediationsResponse,
    ListRemediationsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/remediations/',
  })
}

/**
 * @deprecated
 * Create Remediation
 */
export const createRemediation = <ThrowOnError extends boolean = false>(
  options: Options<CreateRemediationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateRemediationResponse,
    CreateRemediationError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/remediations/',
  })
}

/**
 * @deprecated
 * Delete Remediation
 */
export const deleteRemediation = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteRemediationData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteRemediationResponse,
    DeleteRemediationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/remediations/{remediation_id}',
  })
}

/**
 * @deprecated
 * Get Remediation
 */
export const getRemediation = <ThrowOnError extends boolean = false>(
  options?: Options<GetRemediationData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetRemediationResponse, GetRemediationError, ThrowOnError>(
    {
      ...options,
      url: '/api/projects/{project_id}/remediations/{remediation_id}',
    }
  )
}

/**
 * @deprecated
 * Get Remediation With Resolved Logs Count
 */
export const getRemediationWithResolvedLogsCount = <ThrowOnError extends boolean = false>(
  options?: Options<GetRemediationWithResolvedLogsCountData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetRemediationWithResolvedLogsCountResponse,
    GetRemediationWithResolvedLogsCountError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/remediations/{remediation_id}/resolved_logs_count',
  })
}

/**
 * @deprecated
 * Edit Draft Answer
 */
export const editDraftAnswer = <ThrowOnError extends boolean = false>(
  options: Options<EditDraftAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    EditDraftAnswerResponse,
    EditDraftAnswerError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/remediations/{remediation_id}/edit_draft_answer',
  })
}

/**
 * @deprecated
 * Edit Answer
 */
export const editAnswer = <ThrowOnError extends boolean = false>(
  options: Options<EditAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<EditAnswerResponse, EditAnswerError, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/remediations/{remediation_id}/edit_answer',
  })
}

/**
 * @deprecated
 * Publish Remediation
 */
export const publishRemediation = <ThrowOnError extends boolean = false>(
  options?: Options<PublishRemediationData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PublishRemediationResponse,
    PublishRemediationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/remediations/{remediation_id}/publish',
  })
}

/**
 * @deprecated
 * Pause Remediation
 */
export const pauseRemediation = <ThrowOnError extends boolean = false>(
  options?: Options<PauseRemediationData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PauseRemediationResponse,
    PauseRemediationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/remediations/{remediation_id}/pause',
  })
}

/**
 * @deprecated
 * Unpause Remediation
 */
export const unpauseRemediation = <ThrowOnError extends boolean = false>(
  options?: Options<UnpauseRemediationData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UnpauseRemediationResponse,
    UnpauseRemediationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/remediations/{remediation_id}/unpause',
  })
}

/**
 * @deprecated
 * List Resolved Logs
 * List resolved logs by remediation ID.
 */
export const listResolvedLogs = <ThrowOnError extends boolean = false>(
  options?: Options<ListResolvedLogsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListResolvedLogsResponse,
    ListResolvedLogsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/remediations/{remediation_id}/resolved_logs',
  })
}

/**
 * @deprecated
 * Update Remediation Review Status
 * Update the manual review status override for a remediation.
 */
export const updateRemediationReviewStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRemediationReviewStatusData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UpdateRemediationReviewStatusResponse,
    UpdateRemediationReviewStatusError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/remediations/{remediation_id}/review_status',
  })
}

/**
 * List Deterministic Guardrails
 */
export const listDeterministicGuardrails = <ThrowOnError extends boolean = false>(
  options?: Options<ListDeterministicGuardrailsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListDeterministicGuardrailsResponse,
    ListDeterministicGuardrailsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/deterministic_guardrails/',
  })
}

/**
 * Create Deterministic Guardrail
 */
export const createDeterministicGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<CreateDeterministicGuardrailData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateDeterministicGuardrailResponse,
    CreateDeterministicGuardrailError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/deterministic_guardrails/',
  })
}

/**
 * Delete Deterministic Guardrail
 */
export const deleteDeterministicGuardrail = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteDeterministicGuardrailData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteDeterministicGuardrailResponse,
    DeleteDeterministicGuardrailError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/deterministic_guardrails/{guardrail_id}',
  })
}

/**
 * Get Deterministic Guardrail
 */
export const getDeterministicGuardrail = <ThrowOnError extends boolean = false>(
  options?: Options<GetDeterministicGuardrailData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDeterministicGuardrailResponse,
    GetDeterministicGuardrailError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/deterministic_guardrails/{guardrail_id}',
  })
}

/**
 * Update Deterministic Guardrail
 */
export const updateDeterministicGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDeterministicGuardrailData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateDeterministicGuardrailResponse,
    UpdateDeterministicGuardrailError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/deterministic_guardrails/{guardrail_id}',
  })
}

/**
 * Increment or decrement fallback priority for a deterministic guardrail by 1
 * The smaller the fallback priority number, the higher the priority of the guardrail.
 * If the operation is "increment", fallback priority of the target deterministic guardrail will be decreased by 1, while the fallback priority of the next highest deterministic guardrail will be increased by 1.
 * If the operation is "decrement", the fallback priority of the target deterministic guardrail will be increased by 1, while the fallback priority of the next lowest deterministic guardrail will be decreased by 1.
 */
export const patchDeterministicGuardrailFallbackPriority = <ThrowOnError extends boolean = false>(
  options?: Options<PatchDeterministicGuardrailFallbackPriorityData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PatchDeterministicGuardrailFallbackPriorityResponse,
    PatchDeterministicGuardrailFallbackPriorityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/deterministic_guardrails/{guardrail_id}/fallback_priority',
  })
}

/**
 * List Ai Guidance
 */
export const listAiGuidance = <ThrowOnError extends boolean = false>(
  options?: Options<ListAiGuidanceData, ThrowOnError>
) => {
  return (options?.client ?? client).get<ListAiGuidanceResponse, ListAiGuidanceError, ThrowOnError>(
    {
      ...options,
      url: '/api/projects/{project_id}/guidance_remediations/',
    }
  )
}

/**
 * Create Ai Guidance
 */
export const createAiGuidance = <ThrowOnError extends boolean = false>(
  options: Options<CreateAiGuidanceData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateAiGuidanceResponse,
    CreateAiGuidanceError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/guidance_remediations/',
  })
}

/**
 * Delete Ai Guidance
 */
export const deleteAiGuidance = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteAiGuidanceData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteAiGuidanceResponse,
    DeleteAiGuidanceError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/guidance_remediations/{guidance_id}',
  })
}

/**
 * Get Ai Guidance
 */
export const getAiGuidance = <ThrowOnError extends boolean = false>(
  options?: Options<GetAiGuidanceData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetAiGuidanceResponse, GetAiGuidanceError, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}/guidance_remediations/{guidance_id}',
  })
}

/**
 * Edit Draft Guidance
 */
export const editDraftGuidance = <ThrowOnError extends boolean = false>(
  options: Options<EditDraftGuidanceData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    EditDraftGuidanceResponse,
    EditDraftGuidanceError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/guidance_remediations/{guidance_id}/edit_draft_guidance',
  })
}

/**
 * Edit Guidance
 */
export const editGuidance = <ThrowOnError extends boolean = false>(
  options: Options<EditGuidanceData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<EditGuidanceResponse, EditGuidanceError, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/guidance_remediations/{guidance_id}/edit_guidance',
  })
}

/**
 * Publish Guidance
 */
export const publishGuidance = <ThrowOnError extends boolean = false>(
  options?: Options<PublishGuidanceData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PublishGuidanceResponse,
    PublishGuidanceError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/guidance_remediations/{guidance_id}/publish',
  })
}

/**
 * Create Deterministic Eval
 * Create a new deterministic eval.
 */
export const createDeterministicEval = <ThrowOnError extends boolean = false>(
  options: Options<CreateDeterministicEvalData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateDeterministicEvalResponse,
    CreateDeterministicEvalError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/deterministic_evals/',
  })
}

/**
 * Delete Deterministic Eval
 * Delete a deterministic eval.
 */
export const deleteDeterministicEval = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteDeterministicEvalData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteDeterministicEvalResponse,
    DeleteDeterministicEvalError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/deterministic_evals/{eval_id}',
  })
}

/**
 * Get Deterministic Eval
 * Get a single deterministic eval by ID.
 */
export const getDeterministicEval = <ThrowOnError extends boolean = false>(
  options?: Options<GetDeterministicEvalData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDeterministicEvalResponse,
    GetDeterministicEvalError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/deterministic_evals/{eval_id}',
  })
}

/**
 * Update Deterministic Eval
 * Update a deterministic eval.
 */
export const updateDeterministicEval = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDeterministicEvalData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateDeterministicEvalResponse,
    UpdateDeterministicEvalError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/deterministic_evals/{eval_id}',
  })
}

/**
 * Increment or decrement fallback priority for a deterministic eval by 1
 * The smaller the fallback priority number, the higher the priority of the eval.
 * If the operation is "increment", fallback priority of the target deterministic eval will be decreased by 1, while the fallback priority of the next highest deterministic eval will be increased by 1.
 * If the operation is "decrement", the fallback priority of the target deterministic eval will be increased by 1, while the fallback priority of the next lowest deterministic eval will be decreased by 1.
 */
export const patchDeterministicEvalFallbackPriority = <ThrowOnError extends boolean = false>(
  options?: Options<PatchDeterministicEvalFallbackPriorityData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PatchDeterministicEvalFallbackPriorityResponse,
    PatchDeterministicEvalFallbackPriorityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/deterministic_evals/{eval_id}/fallback_priority',
  })
}

/**
 * List Expert Answers
 */
export const listExpertAnswers = <ThrowOnError extends boolean = false>(
  options?: Options<ListExpertAnswersData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListExpertAnswersResponse,
    ListExpertAnswersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_answers/',
  })
}

/**
 * Create Expert Answer
 */
export const createExpertAnswer = <ThrowOnError extends boolean = false>(
  options: Options<CreateExpertAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateExpertAnswerResponse,
    CreateExpertAnswerError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/expert_answers/',
  })
}

/**
 * Delete Expert Answer
 */
export const deleteExpertAnswer = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteExpertAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteExpertAnswerResponse,
    DeleteExpertAnswerError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}',
  })
}

/**
 * Get Expert Answer
 */
export const getExpertAnswer = <ThrowOnError extends boolean = false>(
  options?: Options<GetExpertAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetExpertAnswerResponse,
    GetExpertAnswerError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}',
  })
}

/**
 * Get Expert Answer With Resolved Logs Count
 */
export const getExpertAnswerWithResolvedLogsCount = <ThrowOnError extends boolean = false>(
  options?: Options<GetExpertAnswerWithResolvedLogsCountData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetExpertAnswerWithResolvedLogsCountResponse,
    GetExpertAnswerWithResolvedLogsCountError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}/resolved_logs_count',
  })
}

/**
 * Edit Draft Expert Answer
 */
export const editDraftExpertAnswer = <ThrowOnError extends boolean = false>(
  options: Options<EditDraftExpertAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    EditDraftExpertAnswerResponse,
    EditDraftExpertAnswerError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}/edit_draft_expert_answer',
  })
}

/**
 * Edit Expert Answer
 */
export const editExpertAnswer = <ThrowOnError extends boolean = false>(
  options: Options<EditExpertAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    EditExpertAnswerResponse,
    EditExpertAnswerError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}/edit_expert_answer',
  })
}

/**
 * Publish Expert Answer
 */
export const publishExpertAnswer = <ThrowOnError extends boolean = false>(
  options?: Options<PublishExpertAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PublishExpertAnswerResponse,
    PublishExpertAnswerError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}/publish',
  })
}

/**
 * Pause Expert Answer
 */
export const pauseExpertAnswer = <ThrowOnError extends boolean = false>(
  options?: Options<PauseExpertAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PauseExpertAnswerResponse,
    PauseExpertAnswerError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}/pause',
  })
}

/**
 * Unpause Expert Answer
 */
export const unpauseExpertAnswer = <ThrowOnError extends boolean = false>(
  options?: Options<UnpauseExpertAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UnpauseExpertAnswerResponse,
    UnpauseExpertAnswerError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}/unpause',
  })
}

/**
 * List Applied To Logs
 */
export const listAppliedToLogs = <ThrowOnError extends boolean = false>(
  options?: Options<ListAppliedToLogsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListAppliedToLogsResponse,
    ListAppliedToLogsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_answers/{expert_answer_id}/applied_to_logs',
  })
}

/**
 * List Issues
 * List issues in a project. Returns a list of the representative query logs for issues in the project.
 */
export const listIssues = <ThrowOnError extends boolean = false>(
  options?: Options<ListIssuesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<ListIssuesResponse, ListIssuesError, ThrowOnError>({
    ...options,
    url: '/api/projects/{project_id}/issues/',
  })
}

/**
 * List Logs By Issue
 */
export const listLogsByIssue = <ThrowOnError extends boolean = false>(
  options?: Options<ListLogsByIssueData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListLogsByIssueResponse,
    ListLogsByIssueError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/issues/logs_by_issue',
  })
}

/**
 * Update Issue Review Status
 */
export const updateIssueReviewStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateIssueReviewStatusData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UpdateIssueReviewStatusResponse,
    UpdateIssueReviewStatusError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/issues/{issue_id}/review_status',
  })
}

/**
 * Tlm Health Check
 * Check the health of the TLM service running within Codex cluster.
 */
export const tlmHealthCheck = <ThrowOnError extends boolean = false>(
  options?: Options<TlmHealthCheckData, ThrowOnError>
) => {
  return (options?.client ?? client).get<TlmHealthCheckResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/tlm/health',
  })
}

/**
 * Tlm Chat
 * Proxy TLM chat request to TLM service.
 */
export const tlmChat = <ThrowOnError extends boolean = false>(
  options?: Options<TlmChatData, ThrowOnError>
) => {
  return (options?.client ?? client).get<TlmChatResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/tlm/chat',
  })
}

/**
 * List Expert Reviews
 */
export const listExpertReviews = <ThrowOnError extends boolean = false>(
  options?: Options<ListExpertReviewsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListExpertReviewsResponse,
    ListExpertReviewsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_reviews/',
  })
}

/**
 * Create Expert Review
 */
export const createExpertReview = <ThrowOnError extends boolean = false>(
  options: Options<CreateExpertReviewData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateExpertReviewResponse,
    CreateExpertReviewError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/expert_reviews/',
  })
}

/**
 * Delete Expert Review
 */
export const deleteExpertReview = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteExpertReviewData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteExpertReviewResponse,
    DeleteExpertReviewError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_reviews/{expert_review_id}',
  })
}

/**
 * Get Expert Review
 */
export const getExpertReview = <ThrowOnError extends boolean = false>(
  options?: Options<GetExpertReviewData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetExpertReviewResponse,
    GetExpertReviewError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_reviews/{expert_review_id}',
  })
}

/**
 * Update Expert Review
 */
export const updateExpertReview = <ThrowOnError extends boolean = false>(
  options: Options<UpdateExpertReviewData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UpdateExpertReviewResponse,
    UpdateExpertReviewError,
    ThrowOnError
  >({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/projects/{project_id}/expert_reviews/{expert_review_id}',
  })
}

/**
 * List Expert Review Applied To Logs
 */
export const listExpertReviewAppliedToLogs = <ThrowOnError extends boolean = false>(
  options?: Options<ListExpertReviewAppliedToLogsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListExpertReviewAppliedToLogsResponse,
    ListExpertReviewAppliedToLogsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{project_id}/expert_reviews/{expert_review_id}/applied_to_logs',
  })
}

/**
 * Get Metrics
 */
export const getMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetMetricsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    ...options,
    url: '/metrics/',
  })
}
